export const HEADACHE_NOTE_APP_STORE_URL = 'https://apps.apple.com/jp/app/id6742800418';
export const HEADACHE_NOTE_GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.ysakuraiappdev.headacheNote&hl=ja';


